<app-version-banner></app-version-banner>

<ng-container *ngIf="(app.is404$ | async) !== true">
  <router-outlet></router-outlet>
  <p-confirmDialog></p-confirmDialog>
  <p-toast key="toast" position="top-center" role="alert"></p-toast>
</ng-container>
<app-notfound *ngIf="(app.is404$ | async) === true"></app-notfound>

